import { getUriParameterBoolean } from '@sas-dvr/ltjs-commons/ltjsUtil';
// eslint-disable-next-line no-restricted-imports
import { getConnection as authGetConnection, deauthorize as authDeauthorize, } from '@sas-dvr/nova-crossorigin-auth';
import { Subscriber } from '@sas-dvr/nova-crossorigin-auth/Subscriber';
// eslint-disable-next-line no-restricted-imports
export { Logon } from '@sas-dvr/nova-crossorigin-auth';
const authorizedSub = new Subscriber({ status: 'authorized' });
let bypassAuth = getUriParameterBoolean('VASDK_BYPASSAUTH', false);
export function getBypassAuthorizationCheck() {
    return bypassAuth;
}
export function setBypassAuthorizationCheck(value) {
    bypassAuth = value;
}
export function getConnection(server, authenticationType) {
    if (bypassAuth) {
        return authorizedSub;
    }
    return authGetConnection(server, authenticationType);
}
export function deauthorize(server, authenticationType) {
    if (bypassAuth) {
        return;
    }
    authDeauthorize(server, authenticationType);
}
